import { useLanguage } from '../../i18n/LanguageContext'

export function Footer() {
  const { t } = useLanguage()

  return (
    <footer className="mt-8 pb-8 text-center">
      <div className="text-slate-500 text-xs space-y-1">
        <p>{t('footer.lastUpdate') as string} {t('footer.rateUpdateDate') as string}</p>
        <p>{t('footer.disclaimer') as string}</p>
      </div>
    </footer>
  )
}
